export default "__VITE_ASSET__Dd3MFW1z__"